import { jsx } from 'react/jsx-runtime';
import { Toolbar } from '../../../../../toolbar/components/Toolbar.js';
import { aiGroup } from '../../../../../toolbar/toolbar.config.js';
import { ToolbarItemType } from '../../../../../toolbar/toolbar.types.js';
import { IconTextEditor20Highlight, IconTextEditor20Comment } from '@fabric-app/icons/svg';
import { throttle } from 'lodash-es';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { styled } from 'styled-components';

const Positioner = styled.div.withConfig({
  displayName: "TextToolbar__Positioner",
  componentId: "sc-770be9d1-0"
})([
  `z-index:130;position:fixed;top:0;left:0;transform:translate(-50%,calc(-100% - 20px));`
]);
const annotationGroup = (onClickAnnotation, onClickHighlight) => ({
  name: "annotation",
  label: "Annotation",
  items: [
    {
      type: ToolbarItemType.Button,
      key: "highlight",
      label: "Highlight",
      icon: /* @__PURE__ */ jsx(IconTextEditor20Highlight, {}),
      onClick: onClickHighlight
    },
    {
      type: ToolbarItemType.Button,
      key: "annotation",
      label: "Annotation",
      icon: /* @__PURE__ */ jsx(IconTextEditor20Comment, {}),
      onClick: onClickAnnotation
    }
  ]
});
const TextToolbar = ({ documentEl, onAnnotationCreation, onHighlightCreation }) => {
  const [toolbarPosition, setToolbarPosition] = useState(null);
  const [toolbarRef, setToolbarRef] = useState(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const onMouseDown = (e) => {
      if (!toolbarRef?.contains(e.target) && (!(e.target instanceof HTMLElement) || !e.target.closest("[data-toolbar]"))) {
        setHidden(true);
      }
    };
    const onMouseUp = (_) => {
      setHidden(false);
    };
    window.addEventListener("mousedown", onMouseDown, true);
    window.addEventListener("mouseup", onMouseUp, true);
    return () => {
      window.removeEventListener("mousedown", onMouseDown, true);
      window.removeEventListener("mouseup", onMouseUp, true);
    };
  }, [
    toolbarRef
  ]);
  useEffect(() => {
    if (!documentEl) return;
    const onSelectionChange = (_) => {
      const selection = window.getSelection();
      if (!selection) {
        setToolbarPosition(null);
        return;
      }
      if (!documentEl.contains(selection.anchorNode)) {
        setToolbarPosition(null);
        return;
      }
      if (selection.type !== "Range") {
        setToolbarPosition(null);
        return;
      }
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = Math.abs(rect.top);
      setToolbarPosition({
        x,
        y
      });
    };
    const throttledHandler = throttle(onSelectionChange, 100, {
      leading: false,
      trailing: true
    });
    document.addEventListener("selectionchange", onSelectionChange);
    document.addEventListener("wheel", throttledHandler, true);
    return () => {
      document.removeEventListener("selectionchange", onSelectionChange);
      document.removeEventListener("wheel", throttledHandler, true);
    };
  }, [
    documentEl
  ]);
  if (hidden) return null;
  return toolbarPosition && /* @__PURE__ */ createPortal(/* @__PURE__ */ jsx(Positioner, {
    style: {
      top: toolbarPosition.y,
      left: toolbarPosition.x
    },
    children: /* @__PURE__ */ jsx(Toolbar.Base, {
      ref: setToolbarRef,
      floating: true,
      groups: [
        annotationGroup(onAnnotationCreation, onHighlightCreation),
        aiGroup(() => window.getSelection()?.toString() ?? "")
      ],
      noSeparator: true
    })
  }), document.querySelector("#tooltip-portal") ?? document.body);
};

export { TextToolbar };
//# sourceMappingURL=TextToolbar.js.map
